import styled from 'styled-components';

const MobileMenuButtonContainer = styled.li`
  display: none;

  .mobile-menu--icon {
    cursor: pointer;
    width: 20px;
    height: 40px;
    margin: 0;
    position: absolute;
    top: 20px;
    right: 28px;
    z-index: 99;

    span {
      margin: 0 auto;
      position: relative;
      top: 17px;
      display: block;
      width: 20px;
      height: 2px;
      background: var(--neutral-7);
      border-radius: 2px;

      &:before,
      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 20px;
        height: 2px;
        background-color: var(--neutral-7);
        border-radius: 2px;
      }

      &:before {
        margin-top: -7px;
      }

      &:after {
        margin-top: 7px;
      }
    }
  }

  .mobile-menu--close-icon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 32px;
    height: 40px;

    &:before,
    &:after {
      background-color: var(--neutral-7);
      content: ' ';
      height: 20px;
      left: 15px;
      position: absolute;
      top: 10px;
      width: 2px;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

  @media (max-width: 1240px) {
    padding: 0 21px;
    display: block;
  }

  @media (max-width: 680px) {
    padding: 0 17px;

    .mobile-menu--icon {
      right: 20px;

      span {
        height: 2px;

        &:before,
        &:after {
          height: 2px;
        }
      }
    }

    .mobile-menu--close-icon {
      right: 13px;

      &:before,
      &:after {
        width: 2px;
      }
    }
  }
`;

export { MobileMenuButtonContainer };
